import { createContext } from 'react'

import type { Dictionary } from './locales/id'
import type { Locale, Localized } from './types'

export interface I18nContextValue {
  locale: Locale
  setLocale: (locale: Locale) => void
  toggleLocale: () => void
  /** False until the visitor has explicitly picked a language (toggle or first-visit prompt). */
  hasChosenLocale: boolean
  /** The active dictionary — read it directly, e.g. `t.nav.home`. */
  t: Dictionary
  /** Resolve a bilingual content field to the active language. */
  pick: <T>(field: Localized<T>) => T
}

export const I18nContext = createContext<I18nContextValue | null>(null)
